module.exports = __webpack_public_path__ + "img/airplane_black.dd027017.png";